import template from './addressLookupSearchAgain.html';
import './style.scss';

export default {
  template,
};
